<template>
  <div class="button__group">
    <button
      v-for="(but,key) in butObjects"
      :key="but.id"
      :id="but.id"
      :disabled="disabled ? 'disabled' : false"
      :class="isActive(key)"
      @click="handleClick(but.id)"
      class="button button--sec"
    >
      <lennoc-icon v-show="but.checked" image="check--large" />
      <span>{{ but.text }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'BaseButtonGroup',
  data () {
    return {
      butObjects: []
    }
  },
  props: {
    buttons: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default () {
        return false
      }
    },
    markClicked: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  mounted () {
    this.butObjects = this.buttons.map(b => {
      return { id: b.id, text: b.text, checked: false }
    })
  },
  methods: {
    handleClick (clickedId) {
      if (this.markClicked) {
        this.butObjects.forEach(b => {
          this.$set(b, 'checked', b.id === clickedId)
        })
      }
      this.$emit('button-click', clickedId)
    },
    isActive (key) {
      return this.butObjects[key].checked === true ? 'button--active' : ''
    }
  }
}
</script>
